// removed by extract-text-webpack-plugin
module.exports = {"login":"app-FtFbn_er","tabs":"app-3Np1F1qR","prefixIcon":"app-k6yoOOlf","getCaptcha":"app-1bwEKprH","submit":"app-2NS4hKYP"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-mian-apps/wbap-admin-login/components/Login/index.less
// module id = 97
// module chunks = 0